// ===== くつひもメーター モーダル開閉ロジック =====

// 閉じるアニメーション中にもう一度開いた時、閉じる予約が後から効いて勝手に閉じないようにする
var _meterCloseTimer = 0;

function openShoelaceMeterModal() {
  var modal = document.getElementById('shoelace-meter-modal');
  if (!modal) return;
  clearTimeout(_meterCloseTimer);
  _meterCloseTimer = 0;
  modal.classList.remove('is-closing');
  modal.classList.add('is-open');
  document.body.style.overflow = 'hidden';

  // 計算機を STEP 0 にリセット
  // goToStep のガード「if (next === currentStep) return;」を回避するため currentStep を一時的に変更
  if (typeof goToStep === 'function' && typeof currentStep !== 'undefined') {
    if (currentStep === 0) {
      // すでに 0 の場合は直接レンダリングをリフレッシュ
      if (typeof renderStep1Guide === 'function') renderStep1Guide();
      if (typeof renderStep3Guide === 'function') renderStep3Guide();
      if (typeof renderStep4Guide === 'function') renderStep4Guide();
      if (typeof renderStep5Guide === 'function') renderStep5Guide();
      if (typeof renderStep6Guide === 'function') renderStep6Guide();
      if (typeof renderStep2Art === 'function') renderStep2Art();
      if (typeof renderStep7Guide === 'function') renderStep7Guide();
      if (typeof updateNav === 'function') updateNav(0);
    } else {
      var prev = currentStep;
      currentStep = prev === 0 ? 1 : prev; // ガード回避
      goToStep(0, 'back');
    }
  }
  // 結果画面のアンケート：書きかけを消し、定規の印も戻す（上の goToStep がアニメーション中で省かれた時のため）
  if (typeof meterFeedbackCall === 'function') meterFeedbackCall('onOpen');
}

function closeShoelaceMeterModal() {
  var modal = document.getElementById('shoelace-meter-modal');
  if (!modal) return;
  if (typeof meterFeedbackCall === 'function') meterFeedbackCall('leave');   // 結果画面のアンケートの書きかけを捨てる
  if (typeof resetResultAnim === 'function') resetResultAnim();
  if (typeof meterHoldStop === 'function') meterHoldStop();
  modal.classList.add('is-closing');
  clearTimeout(_meterCloseTimer);
  _meterCloseTimer = setTimeout(function() {
    _meterCloseTimer = 0;
    modal.classList.remove('is-open');
    modal.classList.remove('is-closing');
    document.body.style.overflow = '';
  }, 240);
}

// ESC キーで閉じる（スマホ画面の定規が開いている時は定規だけを閉じる。定規側が先に受け取って止める）
document.addEventListener('keydown', function(e) {
  if (e.key !== 'Escape') return;
  if (e.defaultPrevented || (window.LaceRuler && window.LaceRuler.isOpen())) return;
  closeShoelaceMeterModal();
});
